import './App.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PageMarketing from './PageMarketing';
import PageSignupWithGoogle from './PageSignupWithGoogle';
import AdScreenV2 from './AdScreenV2';
import DevicesNew from './devices/DevicesNew';
import DeviceHowToConnect from './devices/DeviceHowToConnect';
import ScreenLogin from './ScreenLogin';
import ScreenLoginSuccess from './ScreenLoginSuccess';
import DeviceStats from './devices/DeviceStats';
import Campaigns from './campaigns/Campaigns';
import Devices from './devices/Devices';
import Home from './Home';
import CampaignNew from './campaigns/CampaignNew';
import DeviceManageContent from './devices/DeviceManageContent';
import Account from './Account';
import VoucherActivation from './VoucherActivation';
import DevicePricing from './devices/DevicePricing';
import CampaignBudgetAllocate from './campaigns/CampaignBudgetAllocate';
import Marketplace from './Marketplace';
import AiTest from './AiTest';
import CampaignTop from './campaigns/CampaignTop';
import PageMarketingV2 from './PageMarketingV2';
import PageMarketingV2Gallery from './PageMarketingV2Gallery';
import V2Home from './V2Home';
import V2HomeMenu from './V2HomeMenu';
import V2DeviceNew from './V2DeviceNew';
import Pricing from './Pricing';
import V2MyAccount from './V2MyAccount';
import V2Devices from './V2Devices';
import V2Campaigns from './V2Campaigns';
import DeviceCampaigns from './devices/DeviceCampaigns';

function App() {
  const menu = <V2HomeMenu />;

  return (
    <div
      className="App"
    >
      <BrowserRouter>
        <Routes>
          <Route
            exact path='/' element={<PageMarketingV2 />}
          />
          <Route path='/old' element={<Home />} />
          <Route path='/login' element={<PageMarketing />} />
          <Route path='/gallery' element={<PageMarketingV2Gallery />} />
          {/* <Route path='/screen' element={<AdScreen />} /> */}
          <Route path='/screen' element={<AdScreenV2 />} />
          <Route path='/screen/login/' element={<ScreenLogin />} />
          <Route path='/screen/login/success/' element={<ScreenLoginSuccess />} />
          <Route path='/signup/google' element={<PageSignupWithGoogle />} />
          <Route path='/campaigns/' element={<Campaigns />} />
          <Route path='/account' element={<Account />} />
          <Route path='/home' element={<Campaigns />} />
          <Route path='/feed' element={<V2Home menu={menu} />} />
          <Route path='/campaign/' element={<CampaignTop menu={menu} />} />
          {/* <Route path='/campaign/audience' element={<CampaignAudience />} /> */}
          {/* <Route path='/campaign/stats' element={<CampaignStats />} /> */}
          {/* <Route path='/campaign/settings' element={<CampaignSettings />} /> */}
          {/* <Route path='/campaign/budget' element={<CampaignBudget />} /> */}
          <Route path='/campaign/budget/allocate' element={<CampaignBudgetAllocate />} />
          <Route path='/campaigns/new' element={<CampaignNew menu={menu} />} />
          <Route path='/devices/' element={<Devices />} />
          <Route path='/devices/new/' element={<DevicesNew />} />
          <Route path='/devices/how_to_connect/' element={<DeviceHowToConnect menu={menu} />} />
          <Route path='/device/campaigns/' element={<DeviceCampaigns menu={menu} />} />
          <Route path='/device/stats/' element={<DeviceStats menu={menu} />} />
          <Route path='/device/pricing/' element={<DevicePricing menu={menu} />} />
          <Route path='/device/manage_content/' element={<DeviceManageContent menu={menu} />} />
          <Route path='/marketplace/' element={<Marketplace />} />
          <Route path='/voucher/activation/' element={<VoucherActivation />} />
          <Route path='/ai/test/' element={<AiTest />} />
          <Route path='/v2/devices/new' element={<V2DeviceNew menu={menu} />} />
          <Route path='/v2/devices' element={<V2Devices menu={menu} />} />
          <Route path='/v2/pricing' element={<Pricing menu={menu} />} />
          <Route path='/myaccount' element={<V2MyAccount menu={menu} />} />
          <Route path='/v2/campaigns' element={<V2Campaigns menu={menu} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;